import React, { type FC } from 'react'

type ProviderProps = Record<string, any>

interface ProviderConfig {
	provider: FC<any>
	props?: ProviderProps
}

interface ComposeProvidersProps {
	providers: ProviderConfig[]
	children: React.ReactNode
}

const composeProviders: FC<ComposeProvidersProps> = ({
	providers,
	children,
}) => {
	return providers.reduceRight((child, { provider, props }) => {
		if (props != null) {
			return React.createElement(provider, props, child)
		} else {
			return React.createElement(provider, null, child)
		}
	}, children)
}

const withMultipleProviders = (
	WrappedComponent: FC<any>,
	providers: ProviderConfig[]
) => {
	return function WithMultipleProviders(props: any) {
		// Construct an object with the expected shape of ComposeProvidersProps
		const composedProvidersProps: ComposeProvidersProps = {
			providers,
			children: <WrappedComponent {...props} />,
		}
		// Call the composedProviders function with the props object
		return composeProviders(composedProvidersProps)
	}
}

export default withMultipleProviders
